// src/components/modals/AuthLocationWatcher.jsx
import { useEffect } from 'react';
import { useUserStore } from '../../store/userStore';

const AuthLocationWatcher = () => {
  const { currUserActive } = useUserStore();

  useEffect(() => {
    // If no user is logged in, do nothing
    if (!currUserActive || !currUserActive.id) return;

    // Check if the DB profile is missing the location
    const hasNoDbLocation = !currUserActive?.location || !currUserActive?.location?.quarter;

    if (hasNoDbLocation) {
      const setupStatus = localStorage.getItem('app-setup-completed');

      // Trigger if not already marked as COMPLETE in this browser
      if (setupStatus !== 'COMPLETE') {
        console.log("WATCHER: Logged-in user missing DB location. Triggering Modal.");
        
        localStorage.setItem('app-setup-completed', 'PENDING');
        window.dispatchEvent(new CustomEvent('trigger-lang-modal'));
      }
    }
  }, [currUserActive]);

  return null;
};

export default AuthLocationWatcher;